var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"fill-height mt-2"},[_vm._v(" Отчёт по расчёту ")])
}
var staticRenderFns = []

export { render, staticRenderFns }